// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { CompleteAttribute } from './CompleteAttribute';
import { BEValueObject } from './BEValueObject';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 值对象属性 实体类
 * 值对象属性
 */
export class ValueObjectAttribute extends CompleteAttribute {
  /** 值对象 的ID */
  private _valueObject_ID: string;

  /** 获取：值对象 的ID */
  public get valueObject_ID() {
    return this._valueObject_ID;
  }

  /** 设置：值对象 的ID */
  public set valueObject_ID(value: string) {
    this._valueObject_ID = value;
  }

  /** 值对象  */
  private _valueObject: BEValueObject;

  /** 获取：值对象  */
  public get valueObject() {
    return this._valueObject;
  }

  /** 设置：值对象  */
  public set valueObject(value: BEValueObject) {
    this._valueObject = value;
    if (value !== null) {
      this.valueObject_ID = value.id;
    } else {
      this.valueObject_ID = '';
    }
  }

  constructor() {
    super();
    this._valueObject_ID = '';
    this._valueObject = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ValueObjectAttribute, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.valueObject_ID = element.valueObject_ID;
      if (hasReference && element.valueObject !== null) {
        this.valueObject = element.valueObject;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.valueObject_ID = json.ValueObject_ID;
    // if (json.ValueObject !== null) {
    //   this.valueObject = BEValueObject.Create(json.ValueObject);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ValueObject_ID = this.valueObject_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): ValueObjectAttribute {
    const valueObjectAttribute = new ValueObjectAttribute();
    valueObjectAttribute.Deserialize(json);
    valueObjectAttribute.json = json;
    return valueObjectAttribute;
  }
}
